<div class="servicos-especialidades-prestador-container">
    <form [formGroup]="form">
        <app-card-content [border]="false" [headerColor]="true" icon="pi pi-cog" title="Serviços Médicos e Especialidades" subtitle="Serviços, especialidades e chefias técnicas do prestador">
            <div card-header class="inline-flex items-center gap-2">
                <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [destaque]="itensEdicao" [destaqueAtivo]="isEditing()" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" />
            </div>

            <div class="flex flex-col gap-4">
                <app-tab-container [options]="options" [(selected)]="selected" [useHeader]="false">
                    <app-tab-content value="SERVICOS">
                        <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
                    </app-tab-content>
                    <app-tab-content value="ESPECIALIDADE">
                        <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
                    </app-tab-content>
                </app-tab-container>
            </div>
        </app-card-content>
    </form>
</div>

<ng-template #contentTemplate>
    @if (selected === 'SERVICOS') {
        <div class="flex flex-col gap-4">
            <app-card-content [headerColor]="false" icon="pi pi-cog" title="Serviços">
                <div card-header class="inline-flex items-center gap-3">
                    <label class="inline-flex items-center gap-2 text-sm cursor-pointer">
                        <p-checkbox [binary]="true" [(ngModel)]="exibirTransicaoServicos" (onChange)="onExibirTransicaoChange($event)" />
                        Exibir serviços em Transição
                    </label>
                </div>
                <app-custom-table
                    [metadata]="metadataServicos"
                    [data]="servicosDesenvolvidos"
                    [columnOrder]="colunasServicos"
                    [rowStyle]="rowStyleServico"
                    [totalRecords]="servicosDesenvolvidos.length"
                    [rows]="50"
                    [showViewSwitcher]="false"
                    [showExpandButton]="false"
                    [initialViewMode]="'table'"
                />

                <div class="mt-4 flex flex-wrap gap-6 text-sm">
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 bg-red-500 inline-block"></span>
                        <span>Serviços que necessitam de chefia qualificada e ainda não possuem.</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="w-4 h-4 bg-blue-500 inline-block"></span>
                        <span>Serviços que necessitam de chefia qualificada e possuem.</span>
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" icon="pi pi-history" title="Composição Antiga de Chefes Técnicos">
                <app-custom-table
                    [metadata]="metadataComposicaoAntiga"
                    [data]="composicaoAntigaChefes"
                    [columnOrder]="colunasComposicaoAntiga"
                    [totalRecords]="composicaoAntigaChefes.length"
                    [rows]="50"
                    [showViewSwitcher]="false"
                    [showExpandButton]="false"
                    [showActions]="true"
                    [initialViewMode]="'table'"
                />
            </app-card-content>
        </div>
    }

    @if (selected === 'ESPECIALIDADE') {
        <div class="flex flex-col gap-4">
            <app-card-content [headerColor]="false" icon="pi pi-graduation-cap" title="Especialidades">
                <app-custom-table
                    [metadata]="metadataEspecialidades"
                    [data]="especialidades"
                    [columnOrder]="colunasEspecialidades"
                    [totalRecords]="especialidades.length"
                    [rows]="50"
                    [showViewSwitcher]="false"
                    [showExpandButton]="false"
                    [initialViewMode]="'table'"
                />
            </app-card-content>

            <app-card-content [headerColor]="false" icon="pi pi-id-card" title="Especialidades Sem Médicos Ativos com RQE Correspondente no corpo clínico">
                <app-custom-table
                    [metadata]="metadataEspecialidadesSemRqe"
                    [data]="especialidadesSemMedicosAtivosComRqe"
                    [columnOrder]="colunasEspecialidadesEnfase"
                    [totalRecords]="especialidadesSemMedicosAtivosComRqe.length"
                    [rows]="50"
                    [showViewSwitcher]="false"
                    [showExpandButton]="false"
                    [showActions]="false"
                    [initialViewMode]="'table'"
                />
            </app-card-content>

            <app-card-content [headerColor]="false" icon="pi pi-calendar-times" title="Especialidades Finalizadas">
                <app-custom-table
                    [metadata]="metadataEspecialidadesFinalizadas"
                    [data]="especialidadesFinalizadas"
                    [columnOrder]="colunasEspecialidadesEnfase"
                    [rowStyle]="rowStyleFinalizada"
                    [totalRecords]="especialidadesFinalizadas.length"
                    [rows]="50"
                    [showViewSwitcher]="false"
                    [showExpandButton]="false"
                    [initialViewMode]="'table'"
                />
            </app-card-content>
        </div>
    }
</ng-template>

<p-dialog appDialogoPadrao="pi pi-briefcase" descricao="Serviço oferecido pelo prestador." [(visible)]="servicoDialogVisible" [style]="{ width: '56rem' }" [header]="servicoEmEdicao ? 'Editar Serviço' : 'Adicionar Serviço'">
    <form [formGroup]="servicoDialogForm" class="flex flex-col gap-4">
        <app-card-content [headerColor]="true" icon="pi pi-cog" title="Serviço">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div>
                    <label class="font-semibold block mb-2">Serviço</label>
                    <p-select class="w-full" styleClass="w-full" formControlName="idServico" [options]="servicoOpcoes" optionLabel="servico" optionValue="idServico" placeholder="Selecione" appendTo="body" />
                </div>
                <app-form-date-picker [label]="'Inclusão'" [control]="servicoDialogForm.get('inclusao')" />
                <app-form-date-picker [label]="'Exclusão'" [control]="servicoDialogForm.get('exclusao')" />
            </div>
        </app-card-content>

        <app-card-content [headerColor]="true" icon="pi pi-user" title="Chefe Técnico" subtitle="CRM, UF e Nome somente por seleção da composição.">
            <div card-header class="inline-flex items-center gap-2">
                <p-button label="Substituir" icon="pi pi-search" size="small" [disabled]="!servicoDialogForm.getRawValue().idServico" (click)="abrirComposicaoDialog()" />
                <p-button label="Remover" icon="pi pi-user-minus" severity="danger" outlined size="small" [disabled]="!servicoDialogForm.getRawValue().chefeTecnicoIdMedico" (click)="removerChefeServico()" />
            </div>
            <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
                <div>
                    <label class="font-semibold block mb-2">CRM</label>
                    <input pInputText formControlName="chefeTecnicoCrm" class="w-full" readonly />
                </div>
                <div>
                    <label class="font-semibold block mb-2">UF</label>
                    <input pInputText formControlName="chefeTecnicoUf" class="w-full" readonly />
                </div>
                <div class="xl:col-span-2">
                    <label class="font-semibold block mb-2">Nome</label>
                    <input pInputText formControlName="chefeTecnicoNome" class="w-full" readonly />
                </div>
                <app-form-date-picker [label]="'Entrada'" [control]="servicoDialogForm.get('chefeTecnicoEntrada')" />
                <app-form-date-picker [label]="'Saída'" [control]="servicoDialogForm.get('chefeTecnicoSaida')" />
            </div>
        </app-card-content>
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" severity="secondary" outlined (click)="servicoDialogVisible = false" />
        <p-button label="Salvar" icon="pi pi-check" (click)="salvarServicoDialog()" />
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-check-circle" descricao="O responsável atual será substituído." [(visible)]="confirmarSubstituicaoDialogVisible" [style]="{ width: '32rem' }" header="Confirmar Substituição">
    <form [formGroup]="confirmarSubstituicaoForm" class="flex flex-col gap-4">
        <p class="m-0 text-sm text-500">Informe as datas para encerrar o chefe técnico atual e iniciar o novo chefe.</p>
        <app-form-date-picker [label]="'Entrada atual'" [control]="confirmarSubstituicaoForm.get('entradaOriginal')" />
        <app-form-date-picker [label]="'Data da substituição'" [control]="confirmarSubstituicaoForm.get('dataSubstituicao')" />
        @if (confirmarSubstituicaoForm.touched && !datasSubstituicaoValidas()) {
            <span class="text-sm text-red-500">A data de substituição deve ser igual ou posterior à entrada atual.</span>
        }
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" severity="secondary" outlined (click)="confirmarSubstituicaoDialogVisible = false" />
        <p-button label="Confirmar" icon="pi pi-check" [disabled]="confirmarSubstituicaoForm.invalid || !datasSubstituicaoValidas()" (click)="confirmarSubstituicao()" />
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-briefcase" descricao="Serviço prestado e sua situação." [(visible)]="servicoDetalheDialogVisible" [style]="{ width: '56rem' }" header="Detalhes do Serviço">
    @if (servicoDetalhe) {
        <div class="flex flex-col gap-5">
            <app-card-content [headerColor]="true" icon="pi pi-cog" title="Serviço">
                <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
                    <div>
                        <span class="block text-sm text-500">Serviço</span>
                        <strong>{{ servicoDetalhe.servico }}</strong>
                    </div>
                    <div>
                        <span class="block text-sm text-500">Inclusão</span>
                        <strong>{{ servicoDetalhe.inclusao || '-' }}</strong>
                    </div>
                    <div>
                        <span class="block text-sm text-500">Exclusão</span>
                        <strong>{{ servicoDetalhe.exclusao || '-' }}</strong>
                    </div>
                    <div>
                        <span class="block text-sm text-500">Precisa Chefia</span>
                        <strong>{{ servicoDetalhe.necessitaChefeTecnico ? 'Sim' : 'Não' }}</strong>
                    </div>
                    <div>
                        <span class="block text-sm text-500">Exige RQE</span>
                        <strong>{{ servicoDetalhe.exigeRqe ? 'Sim' : 'Não' }}</strong>
                    </div>
                    <div>
                        <span class="block text-sm text-500">Exige Diretor</span>
                        <strong>{{ servicoDetalhe.exigeDiretor ? 'Sim' : 'Não' }}</strong>
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="true" icon="pi pi-user" title="Chefe Técnico Atual">
                @if (servicoDetalhe.chefeTecnico) {
                    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
                        <div>
                            <span class="block text-sm text-500">CRM</span>
                            <strong>{{ servicoDetalhe.chefeTecnico.crm }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">UF</span>
                            <strong>{{ servicoDetalhe.chefeTecnico.uf }}</strong>
                        </div>
                        <div class="xl:col-span-2">
                            <span class="block text-sm text-500">Nome</span>
                            <strong>{{ servicoDetalhe.chefeTecnico.nome }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">Entrada</span>
                            <strong>{{ servicoDetalhe.chefeTecnico.entrada || '-' }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">Saída</span>
                            <strong>{{ servicoDetalhe.chefeTecnico.saida || '-' }}</strong>
                        </div>
                    </div>
                } @else {
                    <span class="text-sm text-500">Sem chefe técnico atual</span>
                }
            </app-card-content>

            <app-card-content [headerColor]="true" icon="pi pi-book" title="Regras de Chefia">
                @if (servicoDetalhe.mensagem) {
                    <p class="m-0 text-sm text-500">{{ servicoDetalhe.mensagem }}</p>
                } @else {
                    <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
                        <div>
                            <span class="block text-sm text-500">Norma</span>
                            <strong>{{ servicoDetalhe.norma || '-' }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">Exceção</span>
                            <strong>{{ servicoDetalhe.excecao || '-' }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">Especialidades</span>
                            <strong>{{ servicoDetalhe.especialidades.length ? servicoDetalhe.especialidades.join(', ') : '-' }}</strong>
                        </div>
                        <div>
                            <span class="block text-sm text-500">Áreas de Atuação</span>
                            <strong>{{ servicoDetalhe.areasAtuacao.length ? servicoDetalhe.areasAtuacao.join(', ') : '-' }}</strong>
                        </div>
                    </div>
                }
            </app-card-content>
        </div>
    }
    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" severity="secondary" outlined (click)="servicoDetalheDialogVisible = false" />
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-users" descricao="Escolha o responsável técnico pelo serviço." [(visible)]="composicaoDialogVisible" [style]="{ width: '56rem' }" header="Selecionar médico da composição">
    <p-table [value]="composicaoDisponivel" [paginator]="true" [rows]="8" styleClass="w-full">
        <ng-template pTemplate="header">
            <tr>
                <th>CRM</th>
                <th>UF</th>
                <th>Nome</th>
                <th>Entrada</th>
                <th>Vínculo</th>
                <th class="text-center">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.crm }}</td>
                <td>{{ item.ufMedico }}</td>
                <td>{{ item.nome }}</td>
                <td>{{ item.dtEntrada }}</td>
                <td>{{ item.naturezaVinculo || item.vinculo }}</td>
                <td class="text-center">
                    <p-button label="Selecionar" icon="pi pi-check" size="small" (click)="selecionarChefeComposicao(item)" />
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center py-4 text-500">Nenhum médico disponível na composição</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-book"
    descricao="Especialidade oferecida pelo prestador."
    [(visible)]="especialidadeDialogVisible"
    [style]="{ width: '46rem' }"
    [header]="restaurandoEspecialidade ? 'Restaurar Especialidade' : especialidadeEmEdicao ? 'Editar Especialidade' : 'Adicionar Especialidade'"
>
    <form [formGroup]="especialidadeDialogForm" class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div class="md:col-span-2">
            <label class="font-semibold block mb-2">Especialidade</label>
            <p-select
                class="w-full"
                styleClass="w-full"
                formControlName="idEspecialidade"
                [options]="especialidadeOpcoes"
                optionLabel="dsEspecialidade"
                optionValue="idEspecialidade"
                placeholder="Selecione"
                appendTo="body"
                (onChange)="onEspecialidadeChange($event.value)"
            />
        </div>
        <div class="md:col-span-2">
            <label class="font-semibold block mb-2">Área de Atuação</label>
            <p-select class="w-full" styleClass="w-full" formControlName="idEspecArea" [options]="areaAtuacaoOpcoes" optionLabel="dsAreaAtuacao" optionValue="idEspecArea" placeholder="Selecione" appendTo="body" />
        </div>
        <app-form-date-picker [label]="'Data início'" [control]="especialidadeDialogForm.get('dataInicio')" />
        <app-form-date-picker [label]="'Data fim'" [control]="especialidadeDialogForm.get('dataFim')" />
        <div class="md:col-span-2 flex items-center gap-2">
            <p-checkbox formControlName="enfase" binary="true" inputId="especialidade-enfase" />
            <label for="especialidade-enfase" class="font-semibold">Ênfase</label>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" severity="secondary" outlined (click)="especialidadeDialogVisible = false" />
        <p-button [label]="restaurandoEspecialidade ? 'Restaurar' : 'Salvar'" icon="pi pi-check" (click)="salvarEspecialidadeDialog()" />
    </ng-template>
</p-dialog>
